import { enumItems } from './enumItems';
import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SelectField } from '../components/Table/fields/SelectField';
import { AccommodationPrice } from '../types/entities/AccommodationPrice';
import { DateField } from '../components/Table/fields/DateField';
import { salesPartner } from './salesPartner';

export const accommodationPrice: SchemaWithClient<AccommodationPrice> = {
  name: 'Accommodation Price',
  pluralName: 'Accommodation Price',
  columns: {
    name: {
      name: 'Name',
      required: true,
      fieldRenderer: TextField,
      fieldType: 'text',
    },
    sales_partner: {
      name: 'Sales Partner',
      fieldRenderer: SelectField.tableAdapter(salesPartner),
      switchboard: true,
      url: salesPartner.client.getAllPath,
      tempSchema: salesPartner,
    },
    valid_from: {
      name: 'Valid From',
      fieldRenderer: DateField,
      fieldType: 'date',
    },
    accommodation_type: {
      name: 'Accommodation Type',
      fieldRenderer: SelectField.tableAdapter(enumItems.accommodationType),
      switchboard: true,
      url: enumItems.accommodationType.client.getAllPath,
      tempSchema: enumItems.accommodationType,
    },
    season_from: {
      name: 'Season From',
      fieldRenderer: DateField,
      fieldType: 'date',
    },
    season_to: {
      name: 'Season To',
      fieldRenderer: DateField,
      fieldType: 'date',
    },
    price: {
      name: 'Price',
      fieldRenderer: NumberField,
      fieldType: 'number',
    },
    price_currency: {
      name: 'Price Currency',
      fieldRenderer: SelectField.tableAdapter(enumItems.currency),
      switchboard: true,
      url: enumItems.currency.client.getAllPath,
      tempSchema: enumItems.currency,
    },
    price_person_night: {
      name: 'Price Person/Night',
      fieldRenderer: NumberField,
      fieldType: 'number',
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/accommodation-prices'),
};
